export function formatCurrency(value: number | null | undefined) {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return 'По запросу'
  }

  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 0,
  }).format(value)
}

export function formatDate(value: string | null | undefined) {
  if (!value) {
    return 'Не указано'
  }

  return new Date(value).toLocaleDateString('ru-RU')
}

export function formatDateTime(value: string | null | undefined) {
  if (!value) {
    return 'Не указано'
  }

  return new Date(value).toLocaleString('ru-RU')
}

export function formatShortDateTimeValue(value: string | null | undefined) {
  if (!value) {
    return ''
  }

  const date = new Date(value)
  const offsetMinutes = date.getTimezoneOffset()
  const normalized = new Date(date.getTime() - offsetMinutes * 60_000)

  return normalized.toISOString().slice(0, 16)
}

export function toSqlDateTimeValue(value: string) {
  if (!value) {
    return null
  }

  return `${value.replace('T', ' ')}:00`
}

export function formatStatusLabel(status: string | null | undefined) {
  switch (status) {
    case 'active':
      return 'Активен'
    case 'viewed':
      return 'Просмотрен'
    case 'draft':
      return 'Черновик'
    case 'completed':
      return 'Завершен'
    case 'archived':
      return 'Архив'
    case 'expired':
      return 'Ссылка истекла'
    case 'inactive':
      return 'Ссылка выключена'
    default:
      return status ?? 'Не указано'
  }
}

export function progressPercent(total: number | null | undefined, completed: number | null | undefined) {
  if (!total || total <= 0 || completed === null || completed === undefined) {
    return null
  }

  return Math.max(0, Math.min(100, Math.round((completed / total) * 100)))
}
